/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable indent */
/* eslint-disable @typescript-eslint/indent */
import IconProps, { StyledG } from './IconProps';

function PlusIconSmall(props: IconProps) {
	const { color = 'white' } = props;

	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
			<g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
				<StyledG fill={color} color={color} fillRule="nonzero" transform="translate(-871 -512)">
					<path d="M886.429 520.572h-6.858v6.857a.571.571 0 01-1.142 0v-6.857h-6.858a.572.572 0 010-1.143h6.858v-6.858a.572.572 0 011.142 0v6.858h6.858a.572.572 0 010 1.143z" />
				</StyledG>
			</g>
		</svg>
	);
}

export default PlusIconSmall;
